<template>
  <div class="list-box">

    <div :class="'chip-list ' + alignClass">
      <v-chip
        v-for="(rubric) in rubrics" 
        :key="rubric.id"
        color="primary"
        link
        outlined
        small
        class="rubric-chip"
        @click="showRubric(rubric.id)"
      >{{getRubricFullName(rubric)}}</v-chip>
    </div>

  </div>
</template>

<style scoped>
  .chip-list {
    display: flex;
  }

  .chip-list.start {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .chip-list.end {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap-reverse;
  }

  .rubric-chip {
    margin-right: 10px;
    margin-bottom: 5px;
  }


</style>


<script lang="ts">
  import { Rubric } from '@/interfaces/Rubric.interface';
import { Utils } from '@/scripts/Utils';
  import { Component, Prop, Vue } from 'vue-property-decorator';

  /**
   * @desc affiche en ligne les rubriques indiquées
   */
  @Component({
    components: {
    },
  })
  export default class ArticleRubricList extends Vue {
    
    @Prop({default: []})
    rubrics? : Array<Rubric>;

    @Prop({default: "start"})
    alignClass? : string;

    /**
     * @desc navigue vers la page d'affichage de la rubrique indiquée
     */
    private showRubric(rubricId : number) : void {
      const query = Utils.createUrlQuery({id: rubricId});
      this.$router.push('/rubriques/articles/' + rubricId);
    }

    /**
     * @desc renvoie le nom de la rubrique complet
     */
    private getRubricFullName(rubric : Rubric) : string {
      return Utils.getRubricFullName(rubric.startDate, rubric.endDate, rubric.name);
    }
  }
</script>
